import React from "react";
import { motion } from "framer-motion";

export const easeOutExpo = [0.16, 1, 0.3, 1];

// Masked line-by-line reveal. Pass an array of lines (strings or JSX).
// trigger="load" plays immediately on mount (above-the-fold), "scroll" plays in view.
export function LineReveal({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.1, once = true, trigger = "scroll" }) {
  const anim =
    trigger === "load"
      ? { animate: { y: "0%" } }
      : { whileInView: { y: "0%" }, viewport: { once, margin: "-40px" } };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            className={`block ${lineClassName}`}
            style={{ paddingBottom: "0.12em", marginBottom: "-0.12em", willChange: "transform" }}
            initial={{ y: "100%" }}
            {...anim}
            transition={{ duration: 0.7, ease: easeOutExpo, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Generic fade/slide up reveal on scroll.
export function Reveal({ children, className = "", delay = 0, y = 16, once = true }) {
  return (
    <motion.div
      className={className}
      style={{ willChange: "transform, opacity" }}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.5, ease: easeOutExpo, delay }}
    >
      {children}
    </motion.div>
  );
}

export const staggerContainer = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

export const staggerItem = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: easeOutExpo } },
};
